export default "__VITE_ASSET__TvjuhKz1__ 800w, __VITE_ASSET__B2VXQQ5F__ 1120w";